var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93238 2.9324C4.22876 1.63604 6.02111 0.833334 7.99998 0.833334C9.97885 0.833334 11.7712 1.63604 13.0676 2.9324C14.3639 4.22878 15.1666 6.02113 15.1666 8C15.1666 9.97887 14.3639 11.7712 13.0676 13.0676C11.7712 14.364 9.97885 15.1667 7.99998 15.1667C6.02111 15.1667 4.22876 14.364 2.93238 13.0676C1.63602 11.7712 0.833313 9.97887 0.833313 8C0.833313 6.02113 1.63602 4.22878 2.93238 2.9324ZM7.99998 1.83333C6.29698 1.83333 4.756 2.52301 3.63948 3.63951C2.52299 4.75602 1.83331 6.297 1.83331 8C1.83331 9.703 2.52299 11.244 3.63949 12.3605C4.756 13.477 6.29698 14.1667 7.99998 14.1667C9.70298 14.1667 11.244 13.477 12.3605 12.3605C13.477 11.244 14.1666 9.703 14.1666 8C14.1666 6.297 13.477 4.75602 12.3605 3.63951C11.244 2.52301 9.70298 1.83333 7.99998 1.83333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 3.66667C8.46021 3.66667 8.83331 4.03977 8.83331 4.5C8.83331 4.96023 8.46021 5.33333 7.99998 5.33333C7.53975 5.33333 7.16665 4.96023 7.16665 4.5C7.16665 4.03977 7.53975 3.66667 7.99998 3.66667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 6.66667C6.99998 6.39052 7.22384 6.16667 7.49998 6.16667H8.16665C8.44279 6.16667 8.66665 6.39052 8.66665 6.66667V11.3333C8.66665 11.6095 8.44279 11.8333 8.16665 11.8333C7.8905 11.8333 7.66665 11.6095 7.66665 11.3333V7.16667H7.49998C7.22384 7.16667 6.99998 6.94281 6.99998 6.66667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49998 11.3333C6.49998 11.0572 6.72384 10.8333 6.99998 10.8333H9.33331C9.60946 10.8333 9.83331 11.0572 9.83331 11.3333C9.83331 11.6095 9.60946 11.8333 9.33331 11.8333H6.99998C6.72384 11.8333 6.49998 11.6095 6.49998 11.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.09afbf11.svg";
export { ForwardRef as ReactComponent };